import {Breakpoints, ThemeOptions} from '@mui/material';
import {CSSProperties} from 'react';

import {Tokens} from '../../../../types/generated/Tokens';

export const MuiHelperText = (
  {inputfield, switchInput}: Tokens,
  mediaQueries: Breakpoints
): ThemeOptions['components'] => {
  const {adornments} = inputfield;
  return {
    MuiFormHelperText: {
      styleOverrides: {
        root: {
          color: adornments.desktop.hint.font.color,
          fontFamily: adornments.desktop.hint.font.family,
          fontSize: adornments.desktop.hint.font.size,
          fontWeight: adornments.desktop.hint.font.weight as CSSProperties['fontWeight'],
          lineHeight: adornments.desktop.hint.font.lineHeight,
          marginLeft: 0,
          marginRight: 0,
          marginTop: 0,
          marginBottom: 4,
          '&.labelInstructionText': {
            color: adornments.desktop.description.font.color,
            fontFamily: adornments.desktop.description.font.family,
            lineHeight: adornments.desktop.description.font.lineHeight,
            fontSize: adornments.desktop.description.font.size,
            fontWeight: adornments.desktop.description.font.weight as CSSProperties['fontWeight']
          },
          '&.switchlabelInstructionText': {
            gap: '24px',
            marginLeft: '5px',
            color: switchInput.subtext.desktop.font.color,
            fontFamily: adornments.desktop.description.font.family,
            lineHeight: switchInput.subtext.desktop.font.lineHeight,
            fontSize: '14px',
            fontWeight: switchInput.subtext.desktop.font.weight as CSSProperties['fontWeight'],
            [mediaQueries.down('sm')]: {
              lineHeight: switchInput.subtext.mobile.font.lineHeight,
              fontSize: '14px',
              fontWeight: switchInput.subtext.mobile.font.weight as CSSProperties['fontWeight']
            }
          },
          '& .formErrorMessage': {
            color: adornments.desktop.errortext.font.color,
            fontFamily: adornments.desktop.errortext.font.family,
            lineHeight: adornments.desktop.errortext.font.lineHeight,
            fontSize: adornments.desktop.errortext.font.size,
            fontWeight: adornments.desktop.errortext.font.weight as CSSProperties['fontWeight']
          }
        },
        contained: {
          marginLeft: 0,
          marginRight: 0,
          marginTop: 0,
          marginBottom: 4
        }
      }
    },
    MuiSvgIcon: {
      styleOverrides: {
        root: {},
        colorError: {
          color: adornments.desktop.errortext.icon.color,
          height: adornments.desktop.errortext.icon.height,
          width: adornments.desktop.errortext.icon.width
        }
      }
    }
  };
};
